import { useEffect } from 'react';
export function useDeprecationWarning(componentName, message) {
    useEffect(function () {
        // eslint-disable-next-line no-console
        console.warn("DEPRECATION WARNING: `" + componentName + "` has been deprecated in `@velocity/ui` and will be removed in an upcoming major release.\n" + message);
    }, []);
}
//# sourceMappingURL=useDeprecationWarning.js.map